import { Sheet } from "@/components/ui/sheet"
import { SidebarContent } from "./sidebar"

type Props = {
  open: boolean
  onClose: () => void
}

// Mobile navigation drawer — wraps the same <SidebarContent> tree the
// desktop <Sidebar> renders inside a <Sheet> that slides in from the
// left. Operators tap the hamburger in <MobileTopBar> to open it; the
// drawer auto-dismisses when any nav link is tapped (SidebarContent
// fires `onNavigate` on link click).
//
// Hidden entirely at `lg:` and up — the desktop sidebar is always
// visible there, so this would never appear.
//
// Note: the inner flex layout lives on a child <div>, NOT on the
// <Sheet>'s <dialog> element. Tailwind's `flex` would output
// `display: flex`, which overrides the browser-default `display: none`
// on closed `<dialog>` elements — meaning the drawer would appear at
// page load instead of waiting for a hamburger tap.
export function NavDrawer({ open, onClose }: Props) {
  return (
    <Sheet
      open={open}
      onClose={onClose}
      side="left"
      width="max-w-xs"
      className="lg:hidden"
    >
      <div className="flex h-full flex-col p-4">
        <SidebarContent onNavigate={onClose} />
      </div>
    </Sheet>
  )
}
